/**
 * @generated SignedSource<<08b60317e90a046cc1c3dd07837c2817>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AppOrganizationSlugDestinationInputInputQuery$variables = {
  slug: string;
};
export type AppOrganizationSlugDestinationInputInputQuery$data = {
  readonly viewer: {
    readonly organization: {
      readonly id: string;
    } | null;
  };
};
export type AppOrganizationSlugDestinationInputInputQuery = {
  response: AppOrganizationSlugDestinationInputInputQuery$data;
  variables: AppOrganizationSlugDestinationInputInputQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "slug",
            "variableName": "slug"
          }
        ],
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppOrganizationSlugDestinationInputInputQuery",
    "selections": (v1/*: any*/),
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppOrganizationSlugDestinationInputInputQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aa7f5f656700865d641c5d481d4f9bca",
    "id": null,
    "metadata": {},
    "name": "AppOrganizationSlugDestinationInputInputQuery",
    "operationKind": "query",
    "text": "query AppOrganizationSlugDestinationInputInputQuery(\n  $slug: String!\n) {\n  viewer {\n    organization(slug: $slug) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "35d36bb18627701aebe8a99e49b180e5";

export default node;
